<template>
  <div>
    <div class="landing web-only">
      <div class="row web-only" style="color: white; padding-top: 140px; padding-bottom: 21vh; padding-left: 8%; padding-right: 8%; width: 100%;">
        <div class="col-lg-6 col-md-7 my-auto">
          <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
          <h1 style="font-weight: 900; margin-bottom: 8px;">Stop wasting time</h1>
          <div class="web-only">
            <h3 style="margin-bottom: 4px;">Run your agency smarter with a software solution designed just for you. Your clients and candidates will love it.</h3>
            <!-- <h3>solo and small staffing operations.</h3> -->
          </div>
          <p style="font-size: 1.25rem; margin-top: 15px; margin-bottom: 2px;">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p>
          <!-- <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p> -->
          <!-- <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p> -->
        </div>
        <div class="col-lg-6 col-md-5 my-auto web-only" style="">
          <!-- <img src="../assets/img/home/landing/AdobeStock_285202108_panel_iconcolors2.svg" width="100%" height="" alt="digital recruitment platform"> -->
          <iframe width="560" height="315" src="https://www.youtube.com/embed/cOBFDBlW-L4" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </div>
      </div>
    </div>
    <div class="web-only" style="height: 25vh; min-height: 205px;">
      <div class="row" style="margin-left: 8%;">
        <div class="col-lg-9 p-4" style="">
          <transition name="testimonial" mode="out-in">
            <div class="testimonial" v-if="testimonialCount == 1">
              <p style="font-size: 1.15rem; padding-top: 8px;">"The Enginehire Team have been excellent to work with and provide phenomenal customer service. Their knowledge of the industry and individual customization is unparalleled and their platform has revolutionized the way that my team does business."
                <!-- Enginehire streamlined our candidate in-take process, allowed for ease of communication between staff members, and created a centralized database where all client and candidate information can be easily recorded and stored. We are incredibly grateful for the Enginehire team and strongly recommend them to anyone who would like to upgrade their CRM system and increase overall efficiency. -->
              </p>
              <p>
                <img src="../assets/img/home/customers/lydia.jpg" width="" height="45px" alt="Lydia" class="" style="border-radius: 50%; padding-right: 10px;">
                Lydia B - Owner of <a href="https://www.chicagocollegiatenannies.com/" target="_blank">Chicago Collegiate Nannies</a>
              </p>
            </div>
            <div class="testimonial" v-if="testimonialCount == 2">
              <p style="font-size: 1.15rem; padding-top: 8px;">"The Enginehire Team have been excellent to work with and provide phenomenal customer service. Their knowledge of the industry and individual customization is unparalleled and their platform has revolutionized the way that my team does business."
                <!-- Enginehire streamlined our candidate in-take process, allowed for ease of communication between staff members, and created a centralized database where all client and candidate information can be easily recorded and stored. We are incredibly grateful for the Enginehire team and strongly recommend them to anyone who would like to upgrade their CRM system and increase overall efficiency. -->
              </p>
              <p>
                <img src="../assets/img/home/customers/lydia.jpg" width="" height="45px" alt="Lydia" class="" style="border-radius: 50%; padding-right: 10px;">
                Lydia B - Owner of <a href="https://www.chicagocollegiatenannies.com/" target="_blank">Chicago Collegiate Nannies</a>
              </p>
            </div>
          </transition>
        </div>
        <div class="col-lg-3">
          <p class="center" style="padding-top: 35px;">Trusted By</p>
          <!-- <button @click="incrementLogoCount()"></button> -->
          <transition name="logo" mode="out-in">
            <div v-if="logoCount == 1" class="col customer-logo-container" key="atease">
              <a href="https://www.ateasefamilysolutions.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/at-ease_new-logo_300ppi-PNG.png" width="" height="" alt="At Ease Family Solutions" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 2" class="col customer-logo-container" key="tc">
              <a href="https://trustingconnections.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/trusting_connections-emblem_vector-gold.svg" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 3" class="col customer-logo-container" key="lalune">
              <a href="https://www.lalunesitters.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/LogoLaLuneSittersvector_whitefill.svg" width="" height="" alt="La Lune Sitters" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 4" class="col customer-logo-container" key="pink">
              <a href="https://pinknannies.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/PinkNannies-Circle.svg" width="" height="" alt="Pink Nannies" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 5" class="col customer-logo-container" key="TNM">
              <a href="https://www.trustednannymatch.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/TNM-Monogram-DarkNavy.svg" width="" height="" alt="Trusted Nanny Match" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 6" class="col customer-logo-container" key="wellington">
              <a href="https://www.thewellingtonagency.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/the-wellington-agency-logo.png" width="" height="" alt="The Wellington Agency" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 7" class="col customer-logo-container" key="ttna">
              <a href="https://www.tinytreasuresnyc.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/tiny treasureshi res resized.jpg" width="" height="" alt="Tiny Treasures NYC" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 8" class="col customer-logo-container" key="tnc">
              <a href="https://www.thenannycompany.ca/" target="_blank">
                <img src="../assets/img/home/customer_logos/NAN_logomark_RGB_Evergreen.png" width="" height="" alt="The Nanny Company" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 9" class="col customer-logo-container" key="thenannyhub">
              <a href="https://thenannyhub.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/thenannyhub.png" width="" height="" alt="The Nanny Hub" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 10" class="col customer-logo-container" key="jmk">
              <a href="https://jmknannies.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/IMG_0608.png" width="" height="" alt="JMK Nannies" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 11" class="col customer-logo-container" key="lovingcare">
              <a href="https://www.lovingcarehomeservices.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/LovingCareColor.png" width="" height="" alt="Loving Care Home Services" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 12" class="col customer-logo-container" key="mansfield">
              <a href="https://mansfielddomestics.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/Main Logo Green and Yellow.png" width="" height="" alt="Mansfield Domestics" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 13" class="col customer-logo-container" key="collegiate">
              <a href="https://www.chicagocollegiatenannies.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/collegiate_nannies.svg" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
          </transition>
        </div>
      </div>


      <!-- <div class="row" style="">
        <div class="col customer-logo-container">
          <a href="https://www.ateasefamilysolutions.com/" target="_blank">
            <img src="../assets/img/home/customer_logos/at-ease_new-logo_300ppi-PNG.png" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div>
        <div class="col customer-logo-container">
          <a href="https://trustingconnections.com/" target="_blank">
            <img src="../assets/img/home/customer_logos/trusting_connections-emblem_vector-gold.svg" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div>
        <div class="col customer-logo-container">
          <a href="https://www.lalunesitters.com/" target="_blank">
            <img src="../assets/img/home/customer_logos/LogoLaLuneSittersvector_whitefill.svg" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div>
        <div class="col customer-logo-container">
          <a href="https://pinknannies.com/" target="_blank">
            <img src="../assets/img/home/customer_logos/PinkNannies-Circle.svg" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div>
        <div class="col customer-logo-container">
          <a href="https://www.trustednannymatch.com/" target="_blank">
            <img src="../assets/img/home/customer_logos/TNM-Monogram-DarkNavy.svg" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div>
        <div class="col customer-logo-container">
          <a href="https://www.thewellingtonagency.com/" target="_blank">
            <img src="../assets/img/home/customer_logos/the-wellington-agency-logo.png" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div>
        <div class="col customer-logo-container">
          <a href="https://www.tinytreasuresnyc.com/" target="_blank">
            <img src="../assets/img/home/customer_logos/tiny treasureshi res.jpg" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div>
        <div class="col customer-logo-container">
          <a href="https://www.thenannycompany.ca/" target="_blank">
            <img src="../assets/img/home/customer_logos/NAN_logomark_RGB_Evergreen.png" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div>
        <div class="col customer-logo-container">
          <a href="https://thenannyhub.com/" target="_blank">
            <img src="../assets/img/home/customer_logos/thenannyhub.png" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div>
        <div class="col customer-logo-container">
          <a href="https://jmknannies.com/" target="_blank">
            <img src="../assets/img/home/customer_logos/IMG_0608.png" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div>
        <div class="col customer-logo-container">
          <a href="https://www.lovingcarehomeservices.com/" target="_blank">
            <img src="../assets/img/home/customer_logos/LovingCareColor.png" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div>
        <div class="col customer-logo-container">
          <a href="https://mansfielddomestics.com/" target="_blank">
            <img src="../assets/img/home/customer_logos/Main Logo Green and Yellow.png" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div>
      </div> -->
      <!-- <div class="col customer-logo-container">
          <a href="https://trustingconnections.com/" target="_blank">
            <img src="../assets/img/home/customer_logos/collegiate_nannies.svg" width="" height="" alt="Trusting Connections" class="customer-logo">
          </a>
        </div> -->
    </div>
    <div class="web-only" style="height: 5vh; min-height: 30px; background-color: black;">
      <p class="center" style="color: white; font-size: 0.9rem; padding-top: 1.25vh;">Enginehire Inc. | 1855 755 4473 | <a href="" onclick="Calendly.initPopupWidget({url: 'https://calendly.com/enginehire/30min'});return false;">Book a Demo</a> | info@enginehire.io | Hiring re-engineered.</p>
    </div>
    <!-- <div class="landing">

      <div class="row web-only" style="padding-top: 25vh; padding-bottom: 21vh; padding-left: 10%; padding-right: 10%; width: 100%;">
        <div class="col-lg-6 col-md-7 my-auto">
          <h1 style="font-weight: 900; margin-bottom: 8px;">Be a Modern Recruiter</h1>
          <div class="web-only">
            <h3 style="margin-bottom: 4px;">With the website solution built for</h3>
            <h3>solo and small staffing operations.</h3>
          </div>
          <p style="font-size: 1.2rem; margin-top: 30px; margin-bottom: 2px;">Transform your business with a custom recruitment platform.</p>
          <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p>
          <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p>
        </div>
        <div class="col-lg-6 col-md-5 my-auto web-only" style="">
          <img src="../assets/img/home/landing/AdobeStock_285202108_panel_iconcolors2.svg" width="100%" height="" alt="digital recruitment platform">
        </div>
      </div>

      <div class="mobile-only" style="padding-top: 16vh; padding-bottom: 14vh; padding-left: 10%; padding-right: 10%; width: 100%; text-align: center;">
        <h1 style="font-weight: 900; margin-bottom: 15px;">Be a Modern Recruiter</h1>
        <h3 class="mobile-only" style="margin-bottom: 4px;">With the website solution built for solo and small staffing operations.</h3>
        <img src="../assets/img/home/landing/AdobeStock_285202108_monitor2_iconcolors3.svg" class="mobile-only" style="margin-top: 30px; display: block; text-align: center; margin-left: auto; margin-right: auto;" width="100%" height="" alt="digital recruitment platform">
        <p style="font-size: 1.2rem; margin-top: 30px; margin-bottom: 2px; text-align: center;">Transform your business with a custom recruitment platform. Offer candidates and clients a seamless experience and establish your brand as the go to for your niche.</p>
      </div>
    </div> -->

    <!-- <div style="margin-top: 15vh; margin-bottom: 17vh; padding-left: 10%; padding-right: 10%;">
      <h3 style="text-align: center;" class="mb-3">Enginehire is a complete website system for managing your recruitment business</h3>
      <h5 style="text-align: center; font-weight: 300;">We take care of all of your technological operations and automation, so you can take care of the people.</h5>

      <div class="card-deck mt-4">
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/beautifulwebsite.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Beautiful Website</h4>
            <p class="card-text">Custom designed for you</p>
          </div>
        </div>
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/userprofiles3.1.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Custom User Profiles</h4>
            <p class="card-text">Like your own LinkedIn</p>
          </div>
        </div>
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/briefcase.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Job Postings</h4>
            <p class="card-text">Attract the best applicants</p>
          </div>
        </div>
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/digitalassessments.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Digital Screening</h4>
            <p class="card-text">Objectively evaluate candidate skills</p>
          </div>
        </div>
      </div>
      <div class="card-deck">
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/SMS.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Email+SMS Automation</h4>
            <p class="card-text">Only talk to interested people</p>
          </div>
        </div>
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/blogwriting.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Blog and Events</h4>
            <p class="card-text">Build your brand & community</p>
          </div>
        </div>
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/creditcards.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Integrated Payments</h4>
            <p class="card-text">Don't waste time on invoices</p>
          </div>
        </div>
        <div class="card">
          <img class="card-img-top" src="../assets/img/home/icons/analytics.svg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Data and Analytics</h4>
            <p class="card-text">Make informed decisions</p>
          </div>
        </div>
      </div>
    </div> -->

    <!-- <div style="padding-top: 15vh; padding-bottom: 15vh; padding-left: 10%; padding-right: 10%; background-color: #eaf4fe;">
      <h3 style="text-align: center;" class="mb-3">Meet recruiters like you running their businesses on Enginehire</h3>
      <h5 style="text-align: center; font-weight: 300;">Visit their platforms and imagine what yours might look like, fully customized and optimized!</h5>
      <div class="card-deck mb-1">
        <div class="card testimonial-card">
          <img class="card-img-top" src="../assets/img/home/customers/Hayley2.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Meet Hayley</h4>
            <p class="card-text">CEO of ThriveHire - Recruitment for the global health community</p>
            <h5 class="center pb-2" style="font-weight: 300; max-width: 800px; font-style: italic">It’s been a great opportunity working with EngineHire to build our platform. Their team have been extremely responsive to any of our requests. Their professionalism is top-notch, and they are always open to customizing our platform to best fit the needs of our organization. We highly recommend their work!</h5>
            <div class="visit-platform-button">
              <a class="mylisting-button light-button shadow" href="https://www.thrivehire.co" target="_blank">Visit My Platform</a>
            </div>

          </div>
        </div>
      </div>
      <div class="card-deck mb-5">
        <div class="card testimonial-card">
          <img class="card-img-top" src="../assets/img/home/customers/Steven2.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Meet Steven</h4>
            <p class="card-text">Co-Owner of PharmaShyft - Recruitment platform for pharmacists</p>
            <div class="visit-platform-button">
              <a class="mylisting-button light-button shadow" href="https://www.pharmashyft.com" target="_blank">Visit My Platform</a>
            </div>
          </div>
        </div>
        <div class="card testimonial-card">
          <img class="card-img-top" src="../assets/img/home/customers/Daniel_heart.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Meet Daniel</h4>
            <p class="card-text">CEO of Dame Una Mano - Recruiting in-home caregivers for the elderly</p>
            <div class="visit-platform-button">
              <a class="mylisting-button light-button shadow" href="https://www.serviciosdum.com" target="_blank">Visit My Platform</a>
            </div>
          </div>
        </div>
        <div class="card testimonial-card">
          <img class="card-img-top" src="../assets/img/home/customers/Alex.jpg" alt="Card image cap">
          <div class="card-body">
            <h4 class="card-title">Meet Alex</h4>
            <p class="card-text">CEO of LocalStudent - Helping students find work in their community</p>
            <div class="visit-platform-button">
              <a class="mylisting-button light-button shadow" href="https://www.localstudent.ca" target="_blank">Visit My Platform</a>
            </div>
          </div>
        </div>
      </div>

      <div class="center" style="margin-top: 12vh;">
        <h2>Ready to begin your digital transformation?</h2>
        <h4 style="font-weight: 300;" class="web-only mt-3">Get in touch: info@enginehire.io | 1855 775 4473</h4>
        <h4 style="font-weight: 300;" class="mobile-only mt-3">Get in touch:</h4>
        <h5 style="margin-top: 10px; font-weight: 300;" class="mobile-only">1855 755 4473 | info@enginehire.io</h5>
        <div class="" style="margin-top: 33px;">
          <router-link :to="{ name: 'Contact' }" class="mylisting-button light-button shadow">Book a Demo</router-link>
        </div>
      </div>
    </div> -->

    <div class="mobile-only mobile-landing">
      <div class="" style="color: white; padding-top: 17.5vh; padding-bottom: 60px; padding-left: 2%; padding-right: 2%; width: 100%;">
          <!-- <h1 style="font-weight: 900; margin-bottom: 8px;">The software platform</h1> -->
          <h3 style="font-weight: 900; margin-bottom: 8px;" class="center">Stop wasting time</h3>
          <div class="">
            <h4 style="margin-bottom: 4px;" class="center">Run your agency smarter with a software solution designed just for you. Your clients and candidates will love it.</h4>
            <!-- <h3>solo and small staffing operations.</h3> -->
          </div>
          <div class="center" style="padding-top: 20px; padding-bottom: 20px;">
            <!-- <img src="../assets/img/home/landing/AdobeStock_285202108_panel_iconcolors2.svg" width="100%" height="" alt="digital recruitment platform"> -->
            <iframe width="100%" height="100%" src="https://www.youtube.com/embed/cOBFDBlW-L4" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
          </div>
          <p style="margin-bottom: 2px;" class="center">Custom application forms, scheduling, payments, documents, email+SMS automation, beautiful candidate profiles, powerful client dashboards, jobs, bookings, video, interviews, references, analytics - all in one.</p>
          <!-- <p style="font-size: 1.2rem; margin-bottom: 2px;">Offer candidates and clients a seamless experience and</p> -->
          <!-- <p style="font-size: 1.2rem;" class="mb-5">establish your brand as the go to for your niche.</p> -->
      </div>
    </div>
    <div class="mobile-only" style="padding-top: 50px; padding-bottom: 50px; padding-left: 2%; padding-right: 2%;">
      <!-- <div class="" style="margin-left: 8%;"> -->
        <div class="px-3" style="">
          <p style="font-size: 1.15rem;">"The Enginehire Team have been excellent to work with and provide phenomenal customer service. Their knowledge of the industry and individual customization is unparalleled and their platform has revolutionized the way that my team does business."
            <!-- Enginehire streamlined our candidate in-take process, allowed for ease of communication between staff members, and created a centralized database where all client and candidate information can be easily recorded and stored. We are incredibly grateful for the Enginehire team and strongly recommend them to anyone who would like to upgrade their CRM system and increase overall efficiency. -->
          </p>
          <p>
            <img src="../assets/img/home/customers/lydia.jpg" width="" height="45px" alt="Lydia" class="" style="border-radius: 50%; padding-right: 10px;">
            Lydia B - Owner, <a href="https://www.chicagocollegiatenannies.com/" target="_blank">Collegiate Nannies</a>
          </p>
        </div>
        <hr>
        <div class="">
          <p class="center" style="font-size: 1.15rem; padding-top: 20px; padding-bottom: 10px;">Trusted By</p>
          <!-- <button @click="incrementLogoCount()"></button> -->
          <transition name="logo" mode="out-in">
            <div v-if="logoCount == 1" class="col customer-logo-container" key="atease">
              <a href="https://www.ateasefamilysolutions.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/at-ease_new-logo_300ppi-PNG.png" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 2" class="col customer-logo-container" key="tc">
              <a href="https://trustingconnections.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/trusting_connections-emblem_vector-gold.svg" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 3" class="col customer-logo-container" key="lalune">
              <a href="https://www.lalunesitters.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/LogoLaLuneSittersvector_whitefill.svg" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 4" class="col customer-logo-container" key="pink">
              <a href="https://pinknannies.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/PinkNannies-Circle.svg" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 5" class="col customer-logo-container" key="TNM">
              <a href="https://www.trustednannymatch.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/TNM-Monogram-DarkNavy.svg" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 6" class="col customer-logo-container" key="wellington">
              <a href="https://www.thewellingtonagency.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/the-wellington-agency-logo.png" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 7" class="col customer-logo-container" key="ttna">
              <a href="https://www.tinytreasuresnyc.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/tiny treasureshi res resized.jpg" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 8" class="col customer-logo-container" key="tnc">
              <a href="https://www.thenannycompany.ca/" target="_blank">
                <img src="../assets/img/home/customer_logos/NAN_logomark_RGB_Evergreen.png" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 9" class="col customer-logo-container" key="thenannyhub">
              <a href="https://thenannyhub.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/thenannyhub.png" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 10" class="col customer-logo-container" key="jmk">
              <a href="https://jmknannies.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/IMG_0608.png" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 11" class="col customer-logo-container" key="lovingcare">
              <a href="https://www.lovingcarehomeservices.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/LovingCareColor.png" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 12" class="col customer-logo-container" key="mansfield">
              <a href="https://mansfielddomestics.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/Main Logo Green and Yellow.png" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
            <div v-else-if="logoCount == 13" class="col customer-logo-container" key="collegiate">
              <a href="https://www.chicagocollegiatenannies.com/" target="_blank">
                <img src="../assets/img/home/customer_logos/collegiate_nannies.svg" width="" height="" alt="Trusting Connections" class="customer-logo">
              </a>
            </div>
          </transition>
        </div>
      <!-- </div> -->
    </div>
    <div class="mobile-only py-2" style="background-color: black;">
      <p class="center" style="color: white; font-size: 0.9rem; padding-top: 1.25vh;">Enginehire Inc. | 1855 755 4473 | <a href="" onclick="Calendly.initPopupWidget({url: 'https://calendly.com/enginehire/30min'});return false;">Book a Demo</a> | info@enginehire.io | Hiring re-engineered.</p>
    </div>
  </div>
</template>

<script>
import VueFlip from 'vue-flip';

export default {
  components: {
    'vue-flip': VueFlip
  },
  // https://stackoverflow.com/questions/49849376/vue-js-triggering-a-method-function-every-x-seconds
  mounted: function () {
    window.setInterval(() => {
      this.incrementLogoCount()
    }, 3000)
    window.setInterval(() => {
      this.incrementTestimonialCount()
    }, 5000)
  },
  data() {
    return {
      logoCount: 1,
      testimonialCount: 1,
    }
  },
  methods: {
    incrementLogoCount() {
      if (this.logoCount == 13) {
        this.logoCount = 1
      }
      else {
        this.logoCount += 1
      }
    },
    incrementTestimonialCount() {
      if (this.testimonialCount == 2) {
        this.testimonialCount = 1
      }
      else {
        this.testimonialCount += 1
      }
    },
  },
}
</script>

<style>
.landing {
  /* height: 100vh; */
  background-color: var(--shopify);
  background-color: #fcbf67;
  width: 100%;

  /* height: 75vh; */
  height: 70vh;
  min-height: 560px;
  padding-left: 5%;
  padding-right: 5%;

  background-color: white;
  /* background-image: url('https://thewallpaper.co//wp-content/uploads/2016/10preview/goku-universal-hero-backgrounds-photo-hd-wallpapers-4k-amazing-desktop-wallpapers-mac-desktop-images-widescreen-1080p-digital-photos-1920x1080.jpg'); */
  /* background-image: url('../assets/img/AdobeStock_272829109_Preview2.png'); */
  /* background-image: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg'); */
  /* background: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg') left center; */
  /* background: url('../assets/img/landing/AdobeStock_95578556_crop1.jpeg') left center; */
  /* background: url('../assets/img/landing/employer/AdobeStock_95578556_crop1_resize1.jpeg') left center; */
  background: url('../assets/img/home/landing/AdobeStock_161673435_shaded4 resized compressed.png') left center;
  /* background-size: auto 100%; */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
  /* background-position: left top; */
}

.mobile-landing {
  /* height: 100vh; */
  background-color: var(--shopify);
  background-color: #fcbf67;
  width: 100%;

  /* height: 75vh; */
  /* height: 70vh;  */
  /* min-height: 550px; */
  padding-left: 5%;
  padding-right: 5%;

  background-color: white;
  /* background-image: url('https://thewallpaper.co//wp-content/uploads/2016/10preview/goku-universal-hero-backgrounds-photo-hd-wallpapers-4k-amazing-desktop-wallpapers-mac-desktop-images-widescreen-1080p-digital-photos-1920x1080.jpg'); */
  /* background-image: url('../assets/img/AdobeStock_272829109_Preview2.png'); */
  /* background-image: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg'); */
  /* background: url('../assets/img/AdobeStock_95578556_Preview_crop1.jpeg') left center; */
  /* background: url('../assets/img/landing/AdobeStock_95578556_crop1.jpeg') left center; */
  /* background: url('../assets/img/landing/employer/AdobeStock_95578556_crop1_resize1.jpeg') left center; */
  background: url('../assets/img/home/landing/AdobeStock_161673435_shaded4 resized compressed.png') center center;
  /* background-size: auto 100%; */
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  background-repeat: no-repeat;
  /* background-position: left top; */
}

.customer-logo-container {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  padding-top: 5px;
  padding-bottom: 30px;
}
.customer-logo {
  height: 70px;
}

.feature-card {
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  /* margin-left: 10px; */
  /* margin-right: 10px; */
  /* max-width: 20%; */
  /* width: 99%; */
  /* border: 1px solid gray; */
  box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
.card {
  padding-top: 30px;
  padding-bottom: 20px;
  padding-left: 20px;
  padding-right: 20px;
  /* margin-left: 10px; */
  /* margin-right: 10px; */
  /* max-width: 20%; */
  /* width: 99%; */
  /* border: 1px solid gray; */
  box-shadow: 0 .5rem 1rem rgba(0,0,0,.15);
  text-align: center;
  margin-top: 25px;
  /* margin-left: auto; */
  /* margin-right: auto; */

  border: none;
}
.feature-card img {
  text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 170px;
}
.card img {
  /* text-align: center;
  display: block;
  margin-left: auto;
  margin-right: auto;
  height: 170px; */
}
.feature-card-title {
  margin-top: 15px;
}

.testimonial-card {
  /* background-color: #eaf4fe; */
}
.testimonial-card img {
  /* height: 150px;
  width: 150px;
  border-radius: 50%; */
}

.customer-image {
  border-radius: 50%;
  width: 150px;
}

.visit-platform-button {
  margin-top: 33px;
  margin-bottom: 12px;
}

.logo-enter {
  opacity: 0;
}
.logo-enter-active {
  transition: opacity 1s;
}
.logo-leave {

}
.logo-leave-active {
  transition: opacity 1s;
  opacity: 0;
}

.testimonial-enter {
  opacity: 0;
}
.testimonial-enter-active {
  transition: opacity 1s;
}
.testimonial-leave {

}
.testimonial-leave-active {
  transition: opacity 1s;
  opacity: 0;
}

/* ------------------- SMALL -------------------- */
@media (max-width: 768px) {

  .card {
    margin-top: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue